<template>
  <div
    class="btn-wrapper"
    :class="{'disabled': disabled}"
  >
    <button
      class="btn btn-success"
      :disabled="disabled"
    >
      <!--suppress XmlInvalidId -->
      <label for="file">
        <i class="fa fa-cloud-upload" aria-hidden="true"></i>
        {{ $t('fileBrowser.files.upload') }}
      </label>
    </button>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  data () {
    return {
      $wrapper: null
    }
  },
  props: {
    disabled: Boolean
  },
  mounted () {
    this.$wrapper = $(this.$el)
  },
  updated () {
    if (!this.disabled) {
      this.$wrapper.tooltip('destroy')

      return
    }

    this.$wrapper.tooltip({
      title: this.$t('fileBrowser.files.upload_button_title'),
      placement: 'bottom'
    })
  },
  destroy () {
    this.$wrapper.tooltip('destroy')
  }
}
</script>

<style lang="scss" scoped>
  button label {
    margin: 0;
  }

  .btn-wrapper {
    display: inline-block;

    &.disabled {
      cursor: not-allowed;

      button[disabled] {
        pointer-events: none;
      }
    }
  }
</style>
